import { render } from "./ValidateCompany.vue?vue&type=template&id=7c7a0375&scoped=true&ts=true"
import script from "./ValidateCompany.vue?vue&type=script&lang=ts"
export * from "./ValidateCompany.vue?vue&type=script&lang=ts"

import "./ValidateCompany.vue?vue&type=style&index=0&id=7c7a0375&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7a0375"]])

export default __exports__